import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { ClientFormInput, SimpleSelectData } from 'src/types';
import {
  HomeToStoreAgencyInfo,
  HomeToStoreAgencyState,
  HomeToStoreClientRequestForm,
  HomeToStoreSubmitDataState,
  SuccessHomeToStoreSubmit,
} from '../HomeToStore.types';

export const homeToStoreAgencyExistSelector = (state: RootState): boolean => {
  return !!state.homeToStore.agency.info;
};

export const homeToStoreAgencyState = (state: RootState): HomeToStoreAgencyState => {
  return state.homeToStore.agency;
};

export const homeToStoreAgencyInfoSelector = (state: RootState): HomeToStoreAgencyInfo | null => {
  return state.homeToStore.agency.info;
};

export const homeToStoreFormSenderSelector = (state: RootState): ClientFormInput => {
  return state.homeToStore.form.sender;
};

export const homeToStoreFormReceiverSelector = (state: RootState): ClientFormInput | null => {
  return state.homeToStore.form.receiver;
};

export const homeToStoreFormToAgencySelector = (state: RootState): string => {
  return state.homeToStore.form.toAgency;
};

export const esStoreAgencyNameSelector = createSelector(
  homeToStoreAgencyInfoSelector,
  (info: HomeToStoreAgencyInfo | null): string => {
    return info?.name ?? '';
  },
);

export const homeToStoreAgenciesSelector = (state: RootState): HomeToStoreAgencyInfo[] => {
  return state.homeToStore.agency.agencies;
};

export const homeToStoreSenderIsNotReceiverSelector = (state: RootState): boolean => {
  return state.homeToStore.form.senderIsNotReceiver;
};

export const homeToStoreFormStateSelector = (state: RootState): HomeToStoreClientRequestForm => {
  return state.homeToStore.form;
};

export const homeToStoreSubmitDataIsLoadingSelector = (state: RootState): boolean => {
  return state.homeToStore.submitData.isLoading;
};

export const homeToStoreSubmitDataErrorSelector = (state: RootState): Error | null => {
  return state.homeToStore.submitData.error;
};

export const homeToStoreSubmitDataSuccessSelector = (state: RootState): SuccessHomeToStoreSubmit | null => {
  return state.homeToStore.submitData.success;
};

export const homeToStoreSubmitDataStateSelector = (state: RootState): HomeToStoreSubmitDataState => {
  return state.homeToStore.submitData;
};

export const homeToStoreAgenciesForSelectSelector = createSelector(
  homeToStoreAgenciesSelector,
  (agencies): SimpleSelectData => {
    return agencies.map((agency) => ({ label: agency.name, value: agency.slug }));
  },
);
